import { lazy } from "react";
import { Navigate } from "react-router-dom";
const Error404 = lazy(() => import("../pages/404"));
const Error500 = lazy(() => import("../pages/500"));
const Dashboard = lazy(() => import("../pages/dashboard"));
const Login = lazy(() => import("../pages/login"));
const Page = lazy(() => import("../pages/page"));
const Advertisements = lazy(() =>
  import("../pages/advertisements/advertisements")
);
const AgentsRequests = lazy(() => import("../pages/agents/agentsRequests"));
const PropertiesRequests = lazy(() => import("../pages/propertiesRequests/propertiesRequests"));
const Properties = lazy(() => import("../pages/properties/properties"));
const Companies = lazy(() => import("../pages/companies/companies"));
const CompaniesRequests = lazy(() =>
  import("../pages/companiesRequests/companiesRequests")
);
const dashboardRoutes = [
  {
    path: "/dashboard",
    name: "dashboard",
    element: <Dashboard />,
  },
  {
    path: "/page",
    name: "page",
    element: <Page />,
  },
  {
    path: "/advertisements",
    name: "Advertisements",
    element: <Advertisements />,
  },
  {
    path: "/agents-requests",
    name: "agents-requests",
    element: <AgentsRequests />,
  },
  {
    path: "/companies",
    name: "companies",
    element: <Companies />,
  },
  {
    path: "/companiesRequests",
    name: "companiesRequests",
    element: <CompaniesRequests />,
  },
  {
    path: "/properties-requests",
    name: "propertiesRequests",
    element: <PropertiesRequests />,
  },
  {
    path: "/properties",
    name: "Properties",
    element: <Properties />,
  },
];
const authRoutes = [
  {
    path: "/",
    name: "Login",
    element: <Login />,
  },
  {
    path: "/404",
    name: "404 Error",
    element: <Error404 />,
  },
  {
    path: "/500",
    name: "500 Error",
    element: <Error500 />,
  },
  {
    path: "*",
    name: "404 Error",
    element: <Error404 />,
  },
];
const allAdminRoutes = [...dashboardRoutes];
const allBlankRoutes = [...authRoutes];
export { allAdminRoutes, allBlankRoutes };
